(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('office', {
            parent: 'entity',
            url: '/office?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_BILLER'],
                pageTitle: 'ipmApp.office.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/office/offices.html',
                    controller: 'OfficeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'name,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('office');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('office-detail', {
            parent: 'entity',
            url: '/office/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_BILLER'],
                pageTitle: 'ipmApp.office.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/office/office-detail.html',
                    controller: 'OfficeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('office');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Office', function($stateParams, Office) {
                    return Office.get({id : $stateParams.id});
                }]
            }
        })
        .state('office.new', {
            parent: 'office',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/office/office-dialog.html',
                    controller: 'OfficeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                contacts: [{'id': null, 'phoneNumber': null, 'emailAddress': null}],
                                contactRemoves:[],
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('office', null, { reload: true });
                }, function() {
                    $state.go('office');
                });
            }]
        })
        .state('office.edit', {
            parent: 'office',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/office/office-dialog.html',
                    controller: 'OfficeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['Office', function(Office) {
                            return Office.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('office', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('office.delete', {
            parent: 'office',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/office/office-delete-dialog.html',
                    controller: 'OfficeDeleteController',
                    controllerAs: 'vm',
                    size: 'sm',
                    windowClass: 'absolute-center',
                    resolve: {
                        entity: ['Office', function(Office) {
                            return Office.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('office', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
